import { render, staticRenderFns } from "./CartTotal.vue?vue&type=template&id=2818736a&"
import script from "./CartTotal.vue?vue&type=script&lang=js&"
export * from "./CartTotal.vue?vue&type=script&lang=js&"
import style0 from "./CartTotal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports